import { render } from "./ElectionRatingsView.vue?vue&type=template&id=7dccc665"
import script from "./ElectionRatingsView.vue?vue&type=script&lang=js"
export * from "./ElectionRatingsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__